const ToggleFiltersMobileBtn = ({ label, callback }) => {
  const clickEvent = () => {
    callback(true);
  };
  return (
    <button
      type="button"
      className="button-icon button-filters"
      onClick={() => clickEvent()}
      aria-label={label}
    >
      <span className="icon icon--24">
        <img
          src="/assets/images/filters.svg"
          loading="lazy"
          width="24"
          height="24"
          alt="filter icon"
        />
      </span>
    </button>
  );
};
export default ToggleFiltersMobileBtn;
